import { render, staticRenderFns } from "./HtMessage.vue?vue&type=template&id=705682b8"
import script from "./HtMessage.vue?vue&type=script&lang=js"
export * from "./HtMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports